import { render, staticRenderFns } from "./restriktionen-overview.vue?vue&type=template&id=b34b672c&scoped=true"
import script from "./restriktionen-overview.vue?vue&type=script&lang=js"
export * from "./restriktionen-overview.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-overview.vue?vue&type=style&index=0&id=b34b672c&prod&scoped=true&lang=css"
import style1 from "./restriktionen-overview.vue?vue&type=style&index=1&id=b34b672c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34b672c",
  null
  
)

export default component.exports